export const ACTION_PREFIX = 'STORE'
